import _ from 'underscore';

import Config from '../../config';
import Grid from '../../view/grid';
import Model from '../../model/model';
import Module from '../../core/module';
import Collection from '../../collection';
import Contract from '../../model/contract';
import ContractForm from './contracts.form';
import Contracts from '../../collection/contracts';
import TasksModule from './list';

import { ask, } from '../../utils/popups';
import { asc, desc } from '../../collection/sort';





export default Module.extend( { 

    template: 'module/tasks/contracts.list',

    url() {
        return 'contracts/list';
    },

    open() {
        const {
            page = 1, limit = 10,
            sort = 'title', direction = 'asc',
            activeId,
            filters = {}
        } = this.state() || {};
        this.setState( { page, limit, sort, direction, activeId, filters } );

        const { contracts } = this.options;

        const actions = this.options.actions = {
            
            defaults: 'edit',

            create: {

                disabled:
                    () => 
                        !Config.privileges().includes( 'access_contract' ) ||
                        !Config.privileges().includes( 'create_contract' ) || 
                        !['GLOBAL', 'CLUSTER'].includes( Config.level() ),

                handler:
                    () => this.trigger( ContractForm.OPEN, new Contract() )

            },
            
            edit: {

                disabled:
                    () => 
                        !Config.privileges().includes( 'access_contract' ) ||
                        !Config.privileges().includes( 'update_contract' ) ||
                        !['GLOBAL', 'CLUSTER'].includes( Config.level() ),

                handler:
                    current => this.trigger( ContractForm.OPEN, current.clone() )

            }, 

            destroy: {

                disabled:
                    () => 
                        !Config.privileges().includes( 'access_contract' ) ||
                        !Config.privileges().includes( 'delete_contract' ) ||
                        !['GLOBAL', 'CLUSTER'].includes( Config.level() ),

                handler: 
                    current => ask( 'contract::label - confirm delete',
                        'contract::label - delete', 
                        'actions::yes', 'actions::no',
                        () => contracts.destroy( current ) )
                            .then( () => {
                                const { filtered } = this.options;
                                const { page } = this.state();
                                // mystically model is removed from contracts, source, filtered simultaneously
                                if (filtered.length === 0 && page > 1)
                                    // model was the last on the page - turn page back
                                    this.setState( { page: page - 1, } );
                            } )
                            .then( () => this.render() )
                            .then( () => this.navigated() )

            },
            
        };

        this.options.sorted = new Contracts();
        this.options.filtered = new Contracts( [], { actions, } );
        
        const {
            title = '',
            cluster = null,
            customer = null,
            assignedOrganization = null,
        } = this.state().filters;

        return sortFn( this.state(), this.options.contracts, this.options.sorted )
            .then( () => this.bind( new FilterModel( { 
                title, 
                cluster,
                customer,
                assignedOrganization,
            } ) ) );
    },

    start() {
        const { filtered, } = this.options;
        filtered.plugActionSource( this.Grid );

        this.listenTo( filtered, 'activate deactivate', 
            () => {
                const current = filtered.current();
                const activeId = current ? current.id : undefined;
                this.setState( { activeId, } );
                this.navigated();
            } );

        const fn = () => onFilter.call( this, this.model.toJSON() );
        this.listenTo( this.model, 'change:cluster change:customer change:assignedOrganization', 
            _.debounce( fn, 300 ) );
        this.listenTo( this.model, 'change:title', 
            _.debounce( fn, 300 ) );

        return this.Grid.focus(),
            this;
    },

    stop() {
        const { filtered } = this.options;

        filtered.unplugActionSource( this.Grid );
        this.Grid.ungrab( filtered );
        this.stopListening( filtered );

        this.stopListening( this.model );

        return this;
    },

    serialize() {
        const { clusters, organizations } = this.options;
        const { filtered, } = this.options;
        const { sort, direction, } = this.state();

        this.reFilterGrid();

        return {
            clusters, organizations,
            actionList: filtered.actions,
            collection: filtered,
            direction, sort,
        };
    },

    reFilterGrid() {
        const { sorted, filtered, } = this.options;
        const { activeId, filters = {}, } = this.state();
        const { title, cluster, customer, assignedOrganization } = filters;

        Grid.filter( { search: title, ...this.state() }, 
            cluster,
            sorted, new Collection(), filtered,
            model => {
                const byCustomer = !customer 
                    || model.get( 'customer' ) && model.get( 'customer' ).id == customer.id;
                const byAssignee = !assignedOrganization 
                    || model.get( 'assigned_organization') && model.get( 'assigned_organization' ).id == assignedOrganization.id;
                return byCustomer && byAssignee;
            } );

        const activeIndex = filtered.findIndex( model => +model.id === +activeId );
        if (activeIndex > -1)
            filtered.activate( activeIndex );
        else
            filtered.restoreActive();
    },

    events: {

        'click .-sort'({currentTarget}) {
            const { direction, sort: sortField, } = currentTarget.dataset;
            const { contracts, sorted, } = this.options;

            return this.setState( { page: 1, direction, sort: sortField, } ),
                sortFn( this.state(), contracts, sorted, )
                    .then( () => this.render() )
                    .then( () => this.navigated() );
        },

        'click .-clear-filters'() {
            this.model.clear( { silent: true, } );
            this.model.set( { ...defaultFilters } );
        },

    },

    [Module.event( 'Paging:page')](page) {
        return this.setState( { page: +page, } ),
            this.reFilterGrid(),
            Promise.all( [this.Grid.render(), this.Paging.render()] )
                .then( () => this.navigated() );
    },

    [Module.event( 'nav:map' )]() {
        this.trigger( TasksModule.OPEN_MAP, this.state().tasksFiltersState );
    },

    [Module.event( 'nav:list' )]() {
        this.trigger( TasksModule.OPEN_LIST, this.state().tasksFiltersState );
    },

} );





const defaultFilters = {
    title: '',
    cluster: null,
    customer: null,
    assignedOrganization: null,
};

const FilterModel = Model.extend( {
    computeds: {

        changed: {
            deps: ['title', 'cluster', 'customer', 'assignedOrganization'],
            get() {
                return !!this
                    .diff( new Model( defaultFilters ) )
                    .length;
            }
        }

    }
} );





function onFilter(jsonAttrs) {
    return this.setState( { page: 1, filters: jsonAttrs, } ),
        this.reFilterGrid(),
        Promise.all( [this.Grid.render(), this.Paging.render()] )
            .then( () => this.navigated() ); // todo focus
}

function sortFn({ sort: sortField, direction }, source, dest) {
    const sortById = model => +model.id;
    if (sortField === 'id')
        sortField = sortById;

    const sorting = 'asc' === direction
        ? asc( source.models, [sortField, sortById] )
        : desc( source.models, [sortField, sortById] );

    return sorting.then( sortedModels => dest.reset( sortedModels ) );
}



// WEBPACK FOOTER //
// ./src/js/module/tasks/contracts.list.js